import { COURSE_LIST_REQUEST, HEAD_CHANGE, SINGLE_BUY } from '../actions';
import { NotificationManager } from 'react-notifications';

const BANCARD_VPOST = "https://vpos.infonet.com.py:8888/payment/";

export default function(state=null, action){
  if(state==null) state = { text: "" };
  /*if (state.redirect!==undefined && state.redirect!==null) {
    delete state.redirect;
  }*/
  switch (action.type) {
    case COURSE_LIST_REQUEST:
      return { text: action.payload.data.query };
    case HEAD_CHANGE:
      return { text: "Se muestran: "+action.payload };
    case SINGLE_BUY:
      if(action.payload.data.process_id===undefined){
        NotificationManager.error("Error al comunicarse con el servidor");
        return state;
      }
      let mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      let link = `${BANCARD_VPOST}single_buy?process_id=${action.payload.data.process_id}&from_mobile=${mobile}`;
      return { text: state.text, redirect: link}
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/encabezado_reducer.js